import Wrapper from "../../../layout/Wrapper";
import AgentReportComponent from "../../../screens/reports/agent";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "Agent Report",
	description: "",
};

export default function AgentReport() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<AgentReportComponent />
		</Wrapper>
	);
}